import { combine, withContext, withAsyncEffect } from 'react-hooks-combine'
import { StoreContext } from 'store/context'

import AthleteDetailsPanelComponent from './component'

export const AthleteDetailsPanel = combine(
  withContext('athletsStore', StoreContext, ({ athletes }) => athletes),
  withAsyncEffect({
    deps: ['athleteId'],
    dataName: 'athlete',
    asyncAction({ athletsStore }, { athleteId }) {
      return athletsStore.loadOne(athleteId)
    },
  })
)(AthleteDetailsPanelComponent)
